import { render, staticRenderFns } from "./baseShippingTerm.vue?vue&type=template&id=e1d4b120&"
import script from "./baseShippingTerm.vue?vue&type=script&lang=js&"
export * from "./baseShippingTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1d4b120')) {
      api.createRecord('e1d4b120', component.options)
    } else {
      api.reload('e1d4b120', component.options)
    }
    module.hot.accept("./baseShippingTerm.vue?vue&type=template&id=e1d4b120&", function () {
      api.rerender('e1d4b120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseShippingTerm.vue"
export default component.exports